import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class GetCountriesService {
  constructor(private http: HttpClient) {}

  getCountries(): Promise<any> {
    return this.http
      .get<any>('https://restcountries.eu/rest/v2/region/Africa')
      .toPromise();
  }

  getRates(body: any): Promise<any> {
    const proxyurl = 'https://cors-anywhere.herokuapp.com/';
    const url = 'https://remitfree.com/php/getData.php';

    return this.http.post<any>(proxyurl + url, body).toPromise();
  }
}
